import { z } from 'zod';
import { autoCamelCaseMapping, AutoCamelCaseProps } from '@common/services/fieldMapping';
import { ssoSchema, yesNoSchema } from '@common/types/common';
import { YesNoFlag } from '@common/constants/sharedConstants';

export const dataSourceSchema = z.enum(['TLS', 'EMPTY']);
export type DATA_SOURCES = z.infer<typeof dataSourceSchema>;
export const DATA_SOURCES = dataSourceSchema.enum;

const dbScenarioObject = {
  SCENARIO_ID: z.number(),
  SCENARIO_NAME: z.string(),
  ENABLED_FLAG: yesNoSchema,
  PERIOD_NAME: z.string(),
  PUBLIC_FLAG: yesNoSchema,
  LOCKED_FLAG: yesNoSchema,
  DATA_SOURCE: dataSourceSchema,
  SOURCE_ID: z.number().nullable(),
  SSO: ssoSchema,
  MODIFIED_FLAG: yesNoSchema,
};

export const dbScenarioSchema = z.object(dbScenarioObject).strict();
export const dbTaxBookingDiagnosticsListSchema = z.array(z.object(dbScenarioObject));
export const scenarioSchema = z.object(autoCamelCaseMapping(dbScenarioObject)).strict();
export const scenarioSchemaList = z.array(scenarioSchema);

export type DbScenario = z.infer<typeof dbScenarioSchema>;
export type DbScenarioList = z.infer<typeof dbTaxBookingDiagnosticsListSchema>;
export type Scenario = z.infer<typeof scenarioSchema>;
export type ScenarioList = z.infer<typeof scenarioSchemaList>;


export const scenarioIdSchema = z.union([z.number(), z.string()]).transform(id => parseInt(`${id}`, 10)); // eslint-disable-line radix
export type ScenarioId = z.infer<typeof scenarioIdSchema>;

export type ScenarioInsert = Omit<Scenario, 'scenarioId' | 'sourceId'> & { sourceId?: ScenarioId | null }
export type ScenarioUpdate = Omit<Scenario,
    'periodName' | 'dataSource' | 'modifiedFlag' | 'sso' | 'sourceId' | 'scenarioId'>
export type DBAllowedPeriod = {
  PERIOD_NAME: string,
  PERIOD_YEAR: string,
  PERIOD_NUM: string,
};
export type AllowedPeriod = AutoCamelCaseProps<DBAllowedPeriod>;
export type DBDetail = {
  DETAIL_ID: string,
  SCENARIO_ID: string,
  ACCOUNT_EXCEPTION_ID: string,
  COMPANY_CODE: string,
  COUNTRY_CODE: string,
  COUNTRY_TAX_TYPE: string,
  NAME: string,
  DETAIL_NAME: string,
  LABEL: string,
  FUNCTIONAL_CURRENCY: string,
  OVERRIDE_TAX_CURRENCY: string,
  ACCOUNT: string,
  TOUCHED_FLAG?: YesNoFlag,
  VALUE: number,
};
export type Detail = Omit<AutoCamelCaseProps<DBDetail>, 'countryCode'>
export type DBCompanyCodeCurrency = {
  FUNCTIONAL_CURRENCY: string,
};
export type CompanyCodeCurrency = AutoCamelCaseProps<DBCompanyCodeCurrency>;
export type DBScenarioMember = {
  SCENARIO_ID: ScenarioId,
  MEMBER_NAME: string,
  INCLUDED_FLAG: YesNoFlag,
  COPIED_FLAG: YesNoFlag,
};
export type ScenarioMember = AutoCamelCaseProps<DBScenarioMember>;
